var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 17.6344C4.0375 17.6344 3.85938 17.5625 3.71563 17.4187C3.57188 17.2749 3.5 17.0967 3.5 16.8841C3.5 16.6715 3.57188 16.4934 3.71563 16.3498C3.85938 16.2063 4.0375 16.1345 4.25 16.1345H19.75C19.9625 16.1345 20.1406 16.2064 20.2843 16.3502C20.4281 16.494 20.5 16.6722 20.5 16.8848C20.5 17.0974 20.4281 17.2755 20.2843 17.419C20.1406 17.5626 19.9625 17.6344 19.75 17.6344H4.25ZM4.25 12.7498C4.0375 12.7498 3.85938 12.6779 3.71563 12.5341C3.57188 12.3903 3.5 12.2121 3.5 11.9995C3.5 11.7869 3.57188 11.6088 3.71563 11.4652C3.85938 11.3217 4.0375 11.2499 4.25 11.2499H19.75C19.9625 11.2499 20.1406 11.3218 20.2843 11.4656C20.4281 11.6094 20.5 11.7876 20.5 12.0002C20.5 12.2128 20.4281 12.3909 20.2843 12.5344C20.1406 12.678 19.9625 12.7498 19.75 12.7498H4.25ZM4.25 7.86521C4.0375 7.86521 3.85938 7.7933 3.71563 7.64948C3.57188 7.50568 3.5 7.32748 3.5 7.11488C3.5 6.9023 3.57188 6.72422 3.71563 6.58063C3.85938 6.43703 4.0375 6.36523 4.25 6.36523H19.75C19.9625 6.36523 20.1406 6.43714 20.2843 6.58096C20.4281 6.72478 20.5 6.90298 20.5 7.11556C20.5 7.32816 20.4281 7.50625 20.2843 7.64983C20.1406 7.79342 19.9625 7.86521 19.75 7.86521H4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.d8c5e03cd0a9c55bb07fc96c884b829a.svg";
export { ForwardRef as ReactComponent };